// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2413":"7ea16013","2900":"7fbc1160"}[chunkId] + ".chunk.css";
};